// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderSuccessModal_order-success-modal__3u3sR {
  width: 68rem;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.OrderSuccessModal_order-success-modal__success-gif__7nUxW {
  width: 7.5rem;
  height: 8rem;
  margin-block: 5.8rem 2rem;
}

.OrderSuccessModal_order-success-modal__thanks-text__rxPbE {
  color: var(--primary-color);
  font-size: var(--text-xl);
  font-weight: 700;
  margin-bottom: 2rem;
}

.OrderSuccessModal_order-success-modal__header__49RWy {
  color: #000;
  font-size: var(--text-2xl);
  font-weight: 700;
  margin-bottom: 2rem;
}

.OrderSuccessModal_order-success-modal__contact-text__MLdRd {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
  margin-bottom: 7rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/Modals/OrderSuccessModal/OrderSuccessModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".order-success-modal {\n  width: 68rem;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.order-success-modal__success-gif {\n  width: 7.5rem;\n  height: 8rem;\n  margin-block: 5.8rem 2rem;\n}\n\n.order-success-modal__thanks-text {\n  color: var(--primary-color);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  margin-bottom: 2rem;\n}\n\n.order-success-modal__header {\n  color: #000;\n  font-size: var(--text-2xl);\n  font-weight: 700;\n  margin-bottom: 2rem;\n}\n\n.order-success-modal__contact-text {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n  margin-bottom: 7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order-success-modal": `OrderSuccessModal_order-success-modal__3u3sR`,
	"order-success-modal__success-gif": `OrderSuccessModal_order-success-modal__success-gif__7nUxW`,
	"order-success-modal__thanks-text": `OrderSuccessModal_order-success-modal__thanks-text__rxPbE`,
	"order-success-modal__header": `OrderSuccessModal_order-success-modal__header__49RWy`,
	"order-success-modal__contact-text": `OrderSuccessModal_order-success-modal__contact-text__MLdRd`
};
export default ___CSS_LOADER_EXPORT___;
